<template>
  <div class="layerPop" id="popEndorsement" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">배서출력</p>
        </div>
        <div class="popCon">
          <div class="tabStyle1 txtType">
            <table>
              <caption>
                배서정보
              </caption>
              <colgroup>
                <col width="150" />
                <col width="220" />
                <col width="150" />
                <col width="220" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row" height="50">POLICY NO</th>
                  <td>
                    {{ fnEndrResultdata.body.polNo }} -
                    {{ fnEndrResultdata.body.endrNo }}
                  </td>
                  <th scope="row">DATE</th>
                  <td>{{ fnEndrResultdata.body.endrApvDt }}</td>
                </tr>
                <tr>
                  <th scope="row" height="50">INSURED</th>
                  <td>{{ fnEndrResultdata.body.inspeEngNm }}</td>
                  <th scope="row">INVOICE NO.</th>
                  <td>{{ fnEndrResultdata.body.refnNo1 }}</td>
                </tr>
                <tr>
                  <th scope="row" height="50">
                    PROPERTY<br />
                    COVERED
                  </th>
                  <td colspan="3">
                    품목코드 : [{{ fnEndrResultdata.body.itmCd }}]
                    {{ fnEndrResultdata.body.objDtl }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" height="50">ENDORSEMENT</th>
                  <td colspan="3">{{}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="sortWrap colType mgt30">
            <dl>
              <dt class="fw700">원본</dt>
              <dd>
                <div class="inpSlt w100p">
                  <button type="button" class="sltBtn" title="매수 선택">
                    <span>{{ state.ortxtCpno }}매</span>
                  </button>
                  <ul v-if="fnEndrResultdata.body.pdCd != '27000'">
                    <li v-for="(item, index) in state.endrCntList" :key="index">
                      <button
                        type="button"
                        class="sltOpt"
                        title="선택"
                        @click="onSelectEvent('ortxtCpno', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  </ul>
                  <ul v-if="fnEndrResultdata.body.pdCd == '27000'">
                    <li>
                      <button type="button" class="sltOpt" title="선택">
                        <span>1 매</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </dd>
              <div class="btnWrap w100">
                <button
                  type="button"
                  class="btnType sizeS colorRL"
                  @click="printEndr('100807')"
                >
                  <span>출력</span>
                </button>
              </div>
            </dl>
            <dl>
              <dt class="fw700">Invoice</dt>
              <dd>
                <div class="inpSlt w100p">
                  <button type="button" class="sltBtn" title="매수 선택">
                    <span>{{ state.invoiceCnt }}매</span>
                  </button>
                  <ul v-if="fnEndrResultdata.body.pdCd != '27000'">
                    <li
                      v-for="(item, index) in state.invoiceCntList"
                      :key="index"
                    >
                      <button
                        type="button"
                        class="sltOpt"
                        title="선택"
                        @click="onSelectEvent('invoiceCnt', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  </ul>
                  <ul v-if="fnEndrResultdata.body.pdCd == '27000'">
                    <li>
                      <button type="button" class="sltOpt" title="선택">
                        <span>0 매</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </dd>
              <div class="btnWrap w100">
                <button
                  type="button"
                  class="btnType sizeS colorRL"
                  @click="printEndr('100806')"
                >
                  <span>출력</span>
                </button>
              </div>
            </dl>
          </div>

          <div class="inpCheck mgt20">
            <input type="checkbox" id="except" v-model="state.hopPftOtptYn" />
            <label for="except" class="fs14 fc66">희망이익율 출력 제외</label>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="close()"><span>취소</span></a>
        </div>
        <button
          type="button"
          class="popClose"
          onclick="popClose(this);"
          @click="close()"
        >
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, reactive, inject, defineExpose } from "vue";
import * as codeList from "@/common/code";
import encDownload from "@/common/encDownload.js";

const isVisible = ref(false);
const axios = inject("axios");
const swalAlert = inject("swalAlert");

let fnEndrResultdata = reactive({});

const state = reactive({
  ortxtCpnoList: [], //원본
  invoiceCntList: [], //invoice
  ortxtCpno: "2",
  invoiceCnt: "2",
  hopPftOtptYn: false,
});

const emits = defineEmits(["update:data", "close"]);

//open시 데이터 받아오는 부분
const open = (d) => {
  fnEndrResultdata = d;
  if (fnEndrResultdata.body.pdCd == "27000") {
    state.ortxtCpno = "1";
    state.invoiceCnt = "0";
  }
  isVisible.value = true;
};

const onSelectEvent = (selectId, data) => {
  console.log(data);
  if (selectId == "ortxtCpno") {
    state.ortxtCpno = data.code;
  } else if (selectId == "invoiceCnt") {
    state.invoiceCnt = data.code;
  }
};

const close = () => {
  isVisible.value = false;
  emits("close");
};

const printEndr = async (otptDiv) => {
  if (state.ortxtCpno == "0" && state.invoiceCnt == "0") {
    swalAlert("매수를 확인해 주세요!");
    return;
  }
  //배서 출력시 보내줘야하는 데이터
  let param = {
    ctrId: fnEndrResultdata.body.ctrId, // 계약ID
    endrHisStdNo: fnEndrResultdata.body.endrHisStdNo, // 배서이력기준번호
    endrNo: fnEndrResultdata.body.endrNo, // 배서번호
    polNo: fnEndrResultdata.body.polNo, // 증권번호
    pdCd: "", //fnEndrResultdata.body.pdCd,				  // 상품코드
    otptDiv: otptDiv,
    otptSh: "2",
    polEndrOtptDiv: "2",
    cpyOriNum: "0",
    ortxtCpno: otptDiv == "100807" ? state.ortxtCpno : state.invoiceCnt,
    //invcNum: state.invoiceCnt, // 27000 제어
    hopPftOtptYn: state.hopPftOtptYn ? "N" : "Y", // 희망이익율 체크 기준으로 체크되면 "N", 안되면 "Y"
  };

  let Result = await axios.transaction("FNGCTGFO0175", param);

  // await axios.get("/download.do?addFileNm=" + Result.body.otptPth) // 다운로드 기존
  _.startsWith(Result.body.otptPth, "/")
    ? true
    : (Result.body.otptPth = "/" + Result.body.otptPth);

  let sFile = splitFile(Result.body.otptPth);
  console.log("sFile");
  console.log(sFile);

  // await axios.download(
  //   "/download.do?addFileNm=" + sFile.filename + "&addFilePath=" + sFile.dirPath
  // );

  const encFilePath = await encDownload.encryptData(sFile.dirPath, true);
  const encFileName = await encDownload.encryptData(sFile.filename, true);

  await axios.download(
    "/downloadEnc.do?addFileNm=" + encFileName + "&addFilePath=" + encFilePath
  );

  //await axios.download("/download.do?addFileNm=" + Result.body.otptPth); //탭 형태 신규
  axios.json("/logHisLdg.do", {
    memo: "배서 출력",
    page: window.location.hash,
  });
};

function splitFile(path) {
  const filename = path.split("/").pop();
  const dirPath = path.substring(0, path.lastIndexOf("/")) + "/";
  return { filename, dirPath };
}

async function init() {
  state.endrCntList = codeList.getEndrCntCodeList;
  state.invoiceCntList = codeList.getInvoiceCntCodeList;
}

init();

defineExpose({ open, close });
</script>
